import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

// includeHistory (#1779): the admin editor asks for the rows a view does not get - earlier runs of a step and
// retired steps - so it can show them locked. Every other reader takes the default and sees the live rows only.
export const GetTimelineById = createAsyncThunk(
    'timelines/getTimelineById',
    async (
        arg: {
            id: number;
            isTemplate: boolean;
            includeHistory?: boolean;
            timelineId?: number;
        },
        dispatch: any
    ) => {
        const axios = dispatch.getState().core.axios;
        const historyQuery =
            !arg.isTemplate && arg.includeHistory ? '?includeHistory=true' : '';

        try {
            const response = await axios.get(
                arg.isTemplate
                    ? `/api/Marketplace/TimelineTemplates/${arg.id}`
                    : arg.timelineId
                    ? `/api/Marketplace/Engagements/${arg.id}/timelines/${arg.timelineId}${historyQuery}`
                    : `/api/Marketplace/Engagements/${arg.id}${historyQuery}`
            );

            if (response.status !== 200) {
                throw new Error('Failed to fetch Timeline Template');
            }

            return response.data;
        } catch (error) {
            createNotification(
                `There was an error while loading ${
                    arg.isTemplate ? 'Timeline Template' : 'Engagement'
                } Timeline.`,
                'error'
            );
            throw error;
        }
    }
);
